module.exports = __webpack_public_path__ + "9f57238e01d43306642311d5280c0810.svg";